import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';

const QUERY = gql`
  query PerformanceCenterAdditionalData($dataSource: String!, $workspaceId: ID!) {
    me {
      id
      performanceCenterTextVariationsRequest(dataSource: $dataSource, workspaceId: $workspaceId) {
        id
        campaignsCopyImpressions {
          campaignName
          copyText
          impressions
        }
        performanceCenterTalkingPoints {
          talkingPoint
          copyTexts
          rating
        }
      }
    }
  }
`;

export const queryPerformanceCenterAdditionalData = (dataSource, workspaceId) => {
  return apolloClient
    .query({
      query: QUERY,
      variables: {
        dataSource,
        workspaceId,
      },
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => getSingleProp(data))
    .then((result) => result?.performanceCenterTextVariationsRequest);
};
